import React from 'react';
import PDFViewer from '../../../components/PDFViewer';

export const CourseContentView = ({contentUrl}) => {
    return (
        <PDFViewer docContentUrl={contentUrl} fileName='quiz' />
    );

};